import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpStatusCodes } from '@app/utilities/http-status-codes';

import { AuthorizationService } from '../services/authorization.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthorizationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let errorMessage: string = '';
                    if (error.error instanceof ErrorEvent) {
                        // client-side error
                        errorMessage = `Error: ${error.error.message}`;
                        console.log(errorMessage);
                    } else {
                        switch (error.status) {
                            case HttpStatusCodes.UNAUTHORIZED:
                                console.log(`Error Code: ${error.status}\nMessage: ${error.message}`);
                                break;
                            case HttpStatusCodes.NOT_FOUND:
                                errorMessage = "Not found in database (404).";
                                console.log(errorMessage);
                                break;
                            case HttpStatusCodes.FORBIDDEN:
                                errorMessage = "Illegal access. Forbidden resource (403).";
                                console.log(errorMessage);
                                break;
                            case HttpStatusCodes.INTERNAL_SERVER_ERROR:
                                errorMessage = "Internal server error (500).";
                                console.log(errorMessage);
                                break;
                            case HttpStatusCodes.NOT_IMPLEMENTED:
                                errorMessage = "Users temporary password has expired (501).";
                                console.log(errorMessage);
                                break;
                            default:
                                // All other errors.
                                // TODO: Create toast and toaster.
                                errorMessage = error.error.message || error.statusText;
                                console.log(errorMessage);
                        }
                        return throwError(error);
                    }
                }))
    }
}